import { useEffect, useRef } from "react";
import './luminary.css';
import { animate, svg, stagger } from 'animejs';

const Luminary = () => {
  const svgRef = useRef(null);

  useEffect(() => {
       
    const svgElement = svgRef.current;
    if (!svgElement) return;
    
    svgElement.innerHTML = '';
    
    const width = window.innerWidth;
    const height = window.innerHeight;
    const numPointsPerLayer = 50;
    const maxConnections = 4;
    const minConnections = 4;
    const minPointSpacing = 100;

    function generatePoints(num) {
        const points = [];
        let attempts = 0;
        const maxAttempts = num * 20; 
        
        const topLeftExclusionZone = {
            width: width * 0.6, 
            height: height * 0.6   
        };
        
        while (points.length < num && attempts < maxAttempts) {
            attempts++;
            
            const candidate = {
                x: Math.random() * width,
                y: Math.random() * height,
                connections: 0, 
            };
            
            if (candidate.x < topLeftExclusionZone.width && candidate.y < topLeftExclusionZone.height) {
                continue;
            }

            if (points.every(point => Math.hypot(candidate.x - point.x, candidate.y - point.y) >= minPointSpacing)) {
                points.push(candidate);
            }
        }
        return points;
    }

    function drawLayer(points, layerClass) {
        for (let i = 0; i < points.length; i++) {
            const currentPoint = points[i];
            const distances = [];

            for (let j = 0; j < points.length; j++) {
                if (i !== j) {
                    const distance = Math.hypot(
                        currentPoint.x - points[j].x,
                        currentPoint.y - points[j].y
                    );
                    distances.push({ index: j, distance });
                }
            }

            distances.sort((a, b) => a.distance - b.distance);
            let connectionsMade = 0;

            for (const { index } of distances) {
                if (
                    connectionsMade >= maxConnections ||
                    currentPoint.connections >= maxConnections ||
                    points[index].connections >= maxConnections
                ) {
                    break;
                }

                const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
                line.setAttribute('x1', currentPoint.x);
                line.setAttribute('y1', currentPoint.y);
                line.setAttribute('x2', points[index].x);
                line.setAttribute('y2', points[index].y);
                line.classList.add(layerClass); 
                svgElement.appendChild(line);

                currentPoint.connections++;
                points[index].connections++;
                connectionsMade++;
            }
        }

        for (let i = 0; i < points.length; i++) {
            const currentPoint = points[i];

            while (currentPoint.connections < minConnections) {
                const distances = points
                    .map((point, index) => ({
                        index,
                        point,
                        distance: Math.hypot(
                            currentPoint.x - point.x,
                            currentPoint.y - point.y
                        ),
                    }))
                    .filter(({ index, point }) => index !== i && point.connections < maxConnections);

                distances.sort((a, b) => a.distance - b.distance);

                if (distances.length > 0) {
                    const nearest = distances[0];

                    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
                    line.setAttribute('x1', currentPoint.x);
                    line.setAttribute('y1', currentPoint.y);
                    line.setAttribute('x2', nearest.point.x);
                    line.setAttribute('y2', nearest.point.y);
                    line.classList.add(layerClass); 
                    svgElement.appendChild(line);

                    currentPoint.connections++;
                    nearest.point.connections++;
                } else {
                    break;
                }
            }
        }

       
    }

    const darkPoints = generatePoints(numPointsPerLayer);
    const darkLayer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    svgElement.appendChild(darkLayer);
    
    const originalAppend = svgElement.appendChild;
    
    svgElement.appendChild = function(element) {
        return darkLayer.appendChild(element);
    };
    
    drawLayer(darkPoints, 'dark-purple');
    
    const lightPoints = generatePoints(numPointsPerLayer);
    const lightLayer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    originalAppend.call(svgElement, lightLayer);
    
    svgElement.appendChild = function(element) {
        return lightLayer.appendChild(element);
    };
    
    drawLayer(lightPoints, 'light-purple');
    
    svgElement.appendChild = originalAppend;
    
    const handleResize = () => {
      if (svgElement) {
        svgElement.innerHTML = '';
        svgElement.setAttribute('width', window.innerWidth);
        svgElement.setAttribute('height', window.innerHeight);
        
        const darkLayer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        darkLayer.setAttribute('className', 'dark-purple');
        svgElement.appendChild(darkLayer);
        
        const originalAppend = svgElement.appendChild;
        svgElement.appendChild = function(element) {
            return darkLayer.appendChild(element);
        };
        
        drawLayer(generatePoints(numPointsPerLayer), 'dark-purple');
        
        const lightLayer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        lightLayer.setAttribute('className', 'light-purple');
        originalAppend.call(svgElement, lightLayer);
        
        svgElement.appendChild = function(element) {
            return lightLayer.appendChild(element);
        };
        
        drawLayer(generatePoints(numPointsPerLayer), 'light-purple');
        
        svgElement.appendChild = originalAppend;
        const svg1 = document.querySelector('.polygon_luminary');
    if (svg1) {
      setTimeout(() => {
        svg1.classList.add('loaded');
      }, 100);
      
      animate(svg.createDrawable('.polygon_luminary .light-purple'), {
        draw: ['0 0', '0 1', '1 1'],
        ease: 'inOutQuad',
        duration: 2000,
        delay: stagger(100),
        loop: true
      });
    }
      }
    };
    
    window.addEventListener('resize', handleResize);

    const svg1 = document.querySelector('.polygon_luminary');
    if (svg1) {
      setTimeout(() => {
        svg1.classList.add('loaded');
      }, 100);
      
      animate(svg.createDrawable('.polygon_luminary .light-purple'), {
        draw: ['0 0', '0 1', '1 1'],
        ease: 'inOutQuad',
        duration: 2000,
        delay: stagger(100),
        loop: true
      });
    }
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <svg 
      id="polygon-luminary" 
      ref={svgRef} 
      width={window.innerWidth} 
      height={window.innerHeight} 
      xmlns="http://www.w3.org/2000/svg"
      className="polygon_luminary"
    ></svg>
  );
};

export default Luminary;